<template>
  <div class="d-flex align-center">
    <template v-if="!hideMainButton">
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <div v-bind="props" style="display: inline-block;">
            <v-btn
              size="small"
              icon="mds:add"
              :class="compact ? 'add-card-plus-button compact' : 'add-card-plus-button'"
              :disabled="disabled"
              :style="'background-color: ' + (isHovered ? backgroundColor : 'var(--light-1)') + '!important;'"
              @click.stop="emit('click')"
              @mouseover="isHovered = true"
              @mouseleave="isHovered = false"
            />
          </div>
        </template>
        Add one card of the default type '{{ defaultCardType?.title }}' to the selected event
      </v-tooltip>
      <span v-if="$slots.label" class="ml-1">
        <slot name="label"></slot>
      </span>
    </template>
    <template v-if="showAiButton">
      <span>. Or use AI:&nbsp;&nbsp;</span>
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <div v-bind="props" class="add-card-type-card-ask-ai-button-wrapper" style="display: inline-block;">
            <v-btn
              icon="mds:temp-preferences-custom"
              size="small"
              :disabled="disabled"
              class="add-card-type-card-ask-ai-button"
              :style="'background-color: ' + (isHoveredAI ? backgroundColor : 'var(--light-1)') + '!important;'"
              @click.stop="emit('click-ai')"
              @mouseover="isHoveredAI = true"
              @mouseleave="isHoveredAI = false"
            />
          </div>
        </template>
        Add one card (of default type) with AI
      </v-tooltip>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import cardTypesApi from '@/api/cardTypesApi'

defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  compact: {
    type: Boolean,
    default: false
  },
  showAiButton: {
    type: Boolean,
    default: false
  },
  hideMainButton: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['click', 'click-ai'])

const store = useStore()

const isHovered = ref(false)
const isHoveredAI = ref(false)

const defaultCardType = computed(() => store.getters['cardTypes/defaultCardType'])

const backgroundColor = computed(() => {
  return cardTypesApi.getBackgroundColour(defaultCardType.value)
})
</script>

<style scoped>
.v-btn.v-btn--elevated.add-card-plus-button.compact {
  width: 20px;
  height: 20px;
  font-size: 12px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.v-btn.v-btn--elevated.add-card-plus-button:not(.compact) {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

button.add-card-plus-button:hover,
button.add-card-type-card-ask-ai-button:hover {
  color: white !important;
}

button.add-card-plus-button,
button.add-card-type-card-ask-ai-button {
  color: var(--text-dark) !important;
  transition: background-color 0.2s ease, color 0.2s ease !important;
}
</style>
